<template>
  <footer :class="$style.footer">
    <div>
      <RouterLink
        v-if="entranceGUID"
        :to="{ name: 'dashboard', params: { entranceGUID } }"
      >
        <LogoSvg />
      </RouterLink>
      <div v-else>
        <LogoSvg />
      </div>
    </div>
    <ul :class="$style.links">
      <li
        v-for="(item, index) in links"
        :key="index"
        :class="$style.links__item"
      >
        <RouterLink
          v-if="isInternalLinkType(item)"
          :class="$style.link"
          :to="item.to"
          >{{ item.text }}</RouterLink
        >
        <ExternalLink
          v-else-if="isExternalLinkType(item)"
          :class="$style.link"
          :href="item.href"
          @click="item.callback"
          >{{ item.text }}</ExternalLink
        >
      </li>
    </ul>
    <CopyRight />
  </footer>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { FAQ_URL } from '@/config'
import { type AppLargeFooterFragment } from './AppLargeFooter.generated'
import CopyRight from './CopyRight.vue'
import LogoSvg from './logo.svg?component'
import { TermTypePathNameMap } from '@/pages/TermPage/TermPage.vue'
import { isInternalLinkType, isExternalLinkType } from '@/libs/utilities/link'
import type { ExternalLinkType, InternalLinkType } from '@/types/app'
import ExternalLink from '@/components/atoms/ExternalLink.vue'
import { useLogger } from '@/logger/logger'
import { useEntranceGUIDParam } from '@/features/entrance/useEntranceGUIDParam'

const props = defineProps<{
  // API フェッチが失敗することを考慮して optional にする
  fragment?: AppLargeFooterFragment
}>()

const logger = useLogger()

const { entranceGUID } = useEntranceGUIDParam({ must: false })

type Link = (InternalLinkType | ExternalLinkType) & { callback: () => void }

const links = computed<Link[]>(() => {
  const terms =
    props.fragment?.terms.map(({ type, title }) => ({
      to: {
        name: 'termDetail' as const,
        params: { termTypeName: TermTypePathNameMap[type] },
      },
      text: title,
      callback: () => {},
    })) ?? []

  return [
    {
      href: FAQ_URL,
      text: 'よくあるご質問',
      callback: () => {
        logger.ltlPeople.event.openFAQPage(logger.buildMeta())
      },
    },
    {
      href: 'https://400f.jp/',
      text: '運営会社',
      callback: () => {},
    },
    ...terms,
  ]
})
</script>

<style lang="scss" module>
.footer {
  background-color: $color-surface-backdrop;
  padding: 40px;

  & > *:nth-child(n + 2) {
    margin-top: 24px;
  }
}

.links {
  display: flex;
  gap: 42px;
}

.link {
  color: $color-label-white;

  &:hover {
    color: $color-label-white;
  }
}
</style>
